import styled from 'styled-components';

export const MpPropertyTitle = styled(`h4`)`
	display: block;
	margin-bottom: 15px;
	letter-spacing: -0.32px;
	font-weight: 600;
	font-size: 16px;
	line-height: 24px;
`;
